import { z } from "zod";

import { BlobIdSchema } from "./parts.js";

export const LoginFieldSchema = z.object({
  id: z.string().min(1), label: z.string().min(1).max(120),
  type: z.enum(["username", "password", "code"]), required: z.boolean(),
}).strict();
export type LoginField = z.infer<typeof LoginFieldSchema>;

export const LoginActionSchema = z.object({
  id: z.string().min(1), label: z.string().min(1).max(120),
  kind: z.enum(["submit", "method", "check", "refresh"]),
}).strict();
export type LoginAction = z.infer<typeof LoginActionSchema>;

/** Public page metadata only. Submitted credentials never become card values. */
export const LoginChallengeSchema = z.object({
  origin: z.url(), fields: z.array(LoginFieldSchema).max(12), actions: z.array(LoginActionSchema).max(16),
  qr: z.object({ blobId: BlobIdSchema, mimeType: z.literal("image/png"), kind: z.enum(["qr", "page"]).optional() }).strict().optional(),
  note: z.string().max(300).optional(),
}).strict();
export type LoginChallenge = z.infer<typeof LoginChallengeSchema>;

export const LoginStatusSchema = z.enum(["waiting", "submitting", "completed", "cancelled", "expired", "failed"]);
export type LoginStatus = z.infer<typeof LoginStatusSchema>;

/** This private HTTP request is applied by the host, never appended to a transcript or event. */
export const SubmitLoginRequestSchema = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal("action"), revision: z.number().int().nonnegative(), actionId: z.string().min(1), values: z.record(z.string().max(100), z.string().max(4096)).refine((values) => Object.keys(values).length <= 12).default({}) }).strict(),
  z.object({ kind: z.literal("cancel"), revision: z.number().int().nonnegative() }).strict(),
]);
export type SubmitLoginRequest = z.infer<typeof SubmitLoginRequestSchema>;
